const {
  CREATURE_AMBUSH_DRAKE,
} = require('./../../creatureIdList')

const Ambush_drake_img_HOTDQ = require('./../../../images/creatures/hotdq/ambush_drake.png')

module.exports = {
  [CREATURE_AMBUSH_DRAKE]: Ambush_drake_img_HOTDQ,
}
